import { render, staticRenderFns } from "./retail-billing.vue?vue&type=template&id=1f2437fa&scoped=true"
import script from "./retail-billing.vue?vue&type=script&lang=ts"
export * from "./retail-billing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2437fa",
  null
  
)

export default component.exports